import { mapState, mapGetters } from 'vuex';

import { ProgressFooterToolbar } from 'ipro-ui-kit-vuejs/src/components';
import { WorkerOnBoardingRoutesMixin } from '@/portal/worker-on-boarding/mixins';
import { FePreferenceService } from '@/core/fe-preferences';
import { WorkerService } from '@/core/worker';

// @vue/component
export default {
  components: {
    ProgressFooterToolbar,
  },
  mixins: [
    WorkerOnBoardingRoutesMixin,
  ],
  data() {
    return {
      emails: [],
      numberOfInputs: 1,
    };
  },
  computed: {
    ...mapState(['vendorUser']),
    ...mapGetters({
      businessName: 'workerOnBoarding/selectedBusinessName',
      businessNumber: 'workerOnBoarding/selectedBusinessNumber',
    }),
    showAddAnother() {
      return this.emails.filter(v => v).length === this.numberOfInputs;
    },
    preferenceKey() {
      return WorkerService.getWorkerOnBoardingFePreferenceKey();
    },
  },
  methods: {
    async inviteAssistance(email) {
      const workerUuid = _.get(this.vendorUser, 'worker.uuid');
      const requestParams = {
        email_address: email,
        client_uuid: this.$route.query.client_uuid,
        trading_name: this.businessName,
        business_number: this.businessNumber,
      };

      await WorkerService.inviteAssistance(workerUuid, requestParams);
    },
    async sendInvites() {
      if (this.emails.length) {
        try {
          await Promise.all(this.emails.map(this.inviteAssistance));
          await FePreferenceService.save(this.preferenceKey, {
            invitation_assistances: true,
          });
          this.$router.push(this.routes.invitationsSent);
        } catch (error) {
          // do nothing;
        }
      }
    },
    removeEmail(index) {
      // Add a setTimeout so that the Vuetify clear action finishes before splicing the array
      setTimeout(() => this.emails.splice(index, 1));
      this.numberOfInputs = this.numberOfInputs - 1 || 1;
    },
  },
};
